import { render, staticRenderFns } from "./EngagingMentionItem.vue?vue&type=template&id=a45ae700&scoped=true"
import script from "./EngagingMentionItem.vue?vue&type=script&lang=js"
export * from "./EngagingMentionItem.vue?vue&type=script&lang=js"
import style0 from "./EngagingMentionItem.vue?vue&type=style&index=0&id=a45ae700&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45ae700",
  null
  
)

export default component.exports